import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { isInternationalTheme } from "config/ConfigUtils";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const isInternational = isInternationalTheme();

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // supportedLngs: ["en", "tr", "de"],
    supportedLngs: isInternational ? ["en"] : ["en", "tr"],
    //supportedLngs: ["tr"],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator", "querystring", "cookie", "sessionStorage", "htmlTag", "path", "subdomain"],
      caches: ["cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json?v=1.0.4",
    },
    //fallbackLng: "en",
    fallbackLng: isInternational ? "en" : "tr",
    lng: isInternational ? "en" : undefined, // Force English for International theme
  });

// Update HTML lang attribute when language changes
const updateHtmlLang = (lng) => {
  if (lng) {
    document.documentElement.lang = lng;
  }
};

// Listen for language changes and initialization
i18n.on("languageChanged", updateHtmlLang);
i18n.on("initialized", () => {
  updateHtmlLang(i18n.language);
});

export default i18n;
